import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { InputText } from "primereact/inputtext";
import { json } from "stream/consumers";
import { ISubvendorInvoiceList } from "./Table";
import { format } from "date-fns";
import { ISVInvoiceToUpdatePaymentStatus } from "./SVInvoicesToUpdatePaymentStatus";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";


interface IProps {
    // tableData: ISubvendorInvoiceList[],
    singleData: ISVInvoiceToUpdatePaymentStatus,
    paymentStatus?: string | null,
    open: boolean,
    hideDialoge: () => void,
    toast: any
}

interface formSchema {
    payment_Mode: string,
    transaction_ID: string,
}

const schema = yup.object({
    payment_Mode: yup.string().when('inProcess', val => {
        return (val === true) ?
            yup.string().nullable() :
            yup.string().required("Payment Mode is Required")
    }),
    transaction_ID: yup.string().when('inProcess', val => {
        return (val === true) ?
            yup.string().nullable() :
            yup.string().required("")
    })
});

export const MultiInvoiceStatusUpdate = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ISubvendorInvoiceList[], loading: boolean });
    const [totalInviceAmount, setTotalInviceAmount] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [showTable, setShowTable] = useState<boolean>(false);
    const [showAllInvoicePaymentStatus, setShowAllInvoicePaymentStatus] = useState<boolean>(false);
    const [allInvoicePaymentStatus, setAllInvoicePaymentStatus] = useState<string | null>(null);
    const [selectedSubvendorInvoices, setSelectedSubvendorInvoices] = useState<ISubvendorInvoiceList[]>(tableData.tableData);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<formSchema>({
        resolver: yupResolver(schema),
        //defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onHide = () => {
        setTotalInviceAmount(0);
        setShowTable(false);
        reset({});
        setShowAllInvoicePaymentStatus(false);
        props.hideDialoge();
    };

    const fromDate = (rowData: any) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const generated_Date = (rowData: any) => {
        let date;
        if (rowData.generated_Date) date = format(new Date(rowData.generated_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const toDate = (rowData: any) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const dueDate = (rowData: any) => {
        let date;
        if (rowData.dueDate) date = format(new Date(rowData.dueDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const paymentDate = (rowData: any) => {
        let date;
        if (rowData.payment_Date) date = format(new Date(rowData.payment_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const onSubmitBulk = async (data: formSchema) => {
        if (selectedSubvendorInvoices.length > 0) {
            // let sumOfRecived_Amount = 0;
            // let sumOfInvoice_Amount = 0;
            // selectedSubvendorInvoices.forEach((e: any) => {
            //     sumOfRecived_Amount = sumOfRecived_Amount + Number(e.paidAmount);
            //     sumOfInvoice_Amount = sumOfInvoice_Amount + Number(e.invoiceAmount);
            // });

            // if (showTable === false && Number(data.total_Paid_Amount) !== totalInviceAmount && (data.inProcess !== true)) {
            //     setShowTable(true);
            // } else {
            //     if ((sumOfRecived_Amount !== data.total_Paid_Amount) && (sumOfInvoice_Amount !== data.total_Paid_Amount) && (data.inProcess !== true)) {
            //         props.toast.current.show({ severity: 'error', detail: 'Total Invoice Amount is not equals to Total Recived Amount.', life: 3000 });
            //     } else {
            setLoading(true);
            let bulkData: ISubvendorInvoiceList[] = [];
            // let paymentStatus = "";
            // if (Number(data.total_Paid_Amount) === totalInviceAmount) {
            //     paymentStatus = "Paid";
            // } else if (Number(data.total_Paid_Amount) < totalInviceAmount) {
            //     paymentStatus = "Balance";
            // } else if (Number(data.total_Paid_Amount) > totalInviceAmount) {
            //     paymentStatus = "Over Payment";
            // } else {
            //     paymentStatus = "Pending";
            // };

            // if (Number(data.total_Paid_Amount) === totalInviceAmount) {
            //     bulkData = selectedSubvendorInvoices.map((invoice: ISubvendorInvoiceList) => ({
            //         id: invoice.id,
            //         paymentStatus: invoice.paymentStatus,
            //         paidAmount: invoice.invoiceAmount,
            //         payment_Mode: data.payment_Mode,
            //         transaction_ID: data.transaction_ID,
            //         deduction: Number(invoice.deduction || 0),
            //         remarks: invoice.remarks
            //     }));
            // } else {
            bulkData = selectedSubvendorInvoices.map((invoice: ISubvendorInvoiceList) => ({
                id: invoice.id,
                paymentStatus: invoice.paymentStatus,
                paidAmount: invoice.paidAmount,
                payment_Mode: data.payment_Mode,
                transaction_ID: data.transaction_ID,
                deduction: Number(invoice.deduction || 0),
                remarks: invoice.remarks
            }));
            // }
            const response = await Fetch("InvoiceTracking/updateBulkPaymentStatusOfSubvendor", "PUT", bulkData, `paymentMode=${data.payment_Mode}&transaction=${encodeURIComponent(data.transaction_ID)}`, props.toast);

            if (response) {
                props.toast.current.show({ severity: 'success', detail: 'Invoices updated successfully.', life: 3000 });
                onHide();
            }
            setLoading(false);
            //     }
            // }
        } else props.toast.current.show({ severity: 'error', detail: 'Select At Least 1 Invoices To updated.', life: 3000 });

    };

    // const Payment_Status = [
    //     { name: "-- SELECT --", value: null },
    //     { name: "Pending", value: "Pending" },
    //     { name: "Paid", value: "Paid" },
    //     { name: "Balance", value: "Balance" },
    //     { name: "Over Payment", value: "Over Payment" },
    // ];
    const Payment_Mode = [
        { name: "-- SELECT --", value: null },
        { name: "Cheque", value: "CHEQUE" },
        { name: "NetBanking", value: "NET BANKING" },
        { name: "UPI", value: "UPI" },
        { name: "PayPal", value: "PAYPAL" },
    ];

    const getPaymentStatus = (invoiceAmount: number, recivedAmount: number) => {
        if (`${invoiceAmount}`.trim() === `${recivedAmount}`.trim()) {
            return "Paid";
        } else if (invoiceAmount > recivedAmount) {
            return "Balance";
        } else if (invoiceAmount < recivedAmount) {
            return "Over Payment";
        } else {
            return "Pending";
        }
    }

    // useEffect(() => {
    //     const subscription = watch((value, { name, type }) => {
    //         if (name === "total_Paid_Amount") {
    //             if (value.total_Paid_Amount != null && value.total_Paid_Amount != undefined && Number(value.total_Paid_Amount) != 0) {
    //                 if (Number(value.total_Paid_Amount) === totalInviceAmount) {
    //                     setShowAllInvoicePaymentStatus(prev => prev = true);
    //                     setAllInvoicePaymentStatus(prev => prev = "Paid");
    //                 } else if (Number(value.total_Paid_Amount) < totalInviceAmount) {
    //                     setShowAllInvoicePaymentStatus(prev => prev = true);
    //                     setAllInvoicePaymentStatus(prev => prev = "Balance");
    //                 } else if (Number(value.total_Paid_Amount) > totalInviceAmount) {
    //                     setShowAllInvoicePaymentStatus(prev => prev = true);
    //                     setAllInvoicePaymentStatus(prev => prev = "Over Payment");
    //                 } else {
    //                     setShowAllInvoicePaymentStatus(prev => prev = false);
    //                     setAllInvoicePaymentStatus(prev => prev = "");
    //                 }
    //             }
    //         }
    //     });
    //     return () => subscription.unsubscribe();

    // }, [watch, totalInviceAmount]);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        let query = `subvendor=${props.singleData.vendor_Company_ID}`;
        if (props.paymentStatus !== undefined && props.paymentStatus !== null && props.paymentStatus.trim() !== "") {
            query = query + `&paymentStatus=${props.paymentStatus}`;
        }
        const response = await Fetch("InvoiceTracking/subvendorInvoiceByCompany", "GET", null, query, props.toast);

        if (response) {
            const data: ISubvendorInvoiceList[] = await response.json();
            setTableData({ tableData: data, loading: false });
            setSelectedSubvendorInvoices(data);
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    // useEffect(() => {
    //     if (props.open) {
    //         let sum = 0;
    //         selectedSubvendorInvoices.forEach((e: any) => {
    //             if (e.paymentStatus !== "Paid") {
    //                 setShowTable(prev => prev = true);
    //             }
    //             sum = sum + Number(e.requestedAmount);
    //         });
    //         setTotalInviceAmount(sum);
    //     }
    // }, [selectedSubvendorInvoices]);

    useEffect(() => {

        if (props.open) {
            // setTableData({ tableData: props.tableData, loading: false });
            loadTableData();
            // setSelectedSubvendorInvoices(props.tableData);
            // let sum = 0;
            // props.tableData.forEach((e: any) => {
            //     if (e.paymentStatus !== "Paid") {
            //         setShowTable(prev => prev = true);
            //     }
            //     sum = sum + Number(e.requestedAmount);
            // });
            // setTotalInviceAmount(sum);
        };
    }, [props.open]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    return (
        <>
            <Dialog style={{ width: '70vw' }} visible={props.open} onHide={() => onHide()} header="Bulk Update Payment Status" >
                <form onSubmit={handleSubmit(onSubmitBulk)} className="p-fluid formgrid grid" >
                    {/* <div className='field col-12 md:col-4'>
                        <label>Total Invoice Amount</label>
                        <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>{totalInviceAmount}</p>
                    </div> */}
                    {/* <JVInput required column={3} label="Total Amount To Be Paid" control={control} name="total_Paid_Amount" error={errors.total_Paid_Amount?.message} /> */}
                    {/* {showAllInvoicePaymentStatus && <div className='field col-12 md:col-4'>
                        <label>Payment Status</label>
                        <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>{allInvoicePaymentStatus}</p>
                    </div>} */}
                    <JVDropdown column={3} label="Payment Mode" control={control} name="payment_Mode" options={Payment_Mode} optionLabel="name" optionValue="value" placeholder="Select Payment Mode" error={errors.payment_Mode?.message} />
                    <JVInput required column={3} label="Transaction ID" control={control} name="transaction_ID" error={errors.transaction_ID?.message} />
                    <Button label="Update" type="submit" loading={loading} />
                </form>

                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "25px" }}
                    value={tableData.tableData}
                    loading={tableData.loading}
                    onSelectionChange={(e) => {
                        const value = e.value as ISubvendorInvoiceList[];
                        setSelectedSubvendorInvoices(value);
                    }}
                    selection={selectedSubvendorInvoices}
                    selectionMode="checkbox"
                    dataKey="id"
                >
                    <Column selectionMode="multiple" />
                    <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="consultant_Name" header="Name" />
                    <Column field="vendor_Company_Name" header="Sub Vendor" />
                    {/* <Column field="invoiceDate" header="Generated Date" body={generated_Date} />
                    <Column field="fromDate" header="From Date" body={fromDate} />
                    <Column field="toDate" header="To Date" body={toDate} />
                    <Column field="dueDate" header="Due Date" body={dueDate} /> */}
                    <Column field="invoiceDate" header="Generated Date" style={{minWidth: '140px' }} body={(rowData: any) => safeFormatDate(rowData.invoiceDate, 'dd/MM/yyyy', DateFormat)} />
                    <Column field="fromDate" header="From Date" style={{minWidth: '140px'}} body={(rowData: any) => safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFormat)} />
                    <Column field="toDate" header="To Date"  style={{minWidth: '140px'}} body={(rowData: any) => safeFormatDate(rowData.toDate, 'dd/MM/yyyy', DateFormat)} />
                    <Column field="dueDate" header="Due Date" style={{minWidth: '140px'}} body={(rowData: any) => safeFormatDate(rowData.dueDate, 'dd/MM/yyyy', DateFormat)} />
                    <Column field="invoiceNO" header="Invoice#" />
                    <Column field="invoiceAmount" header="Amout" />
                    <Column field="paymentStatus" header="Payment Status" />
                    <Column field="c_DocumentCompleteStatus" header="Consultant Document Status" body={(rowData) => <p style={rowData.c_DocumentCompleteStatus === true ? {} : { color: "red" }}>{rowData.c_DocumentCompleteStatus === true ? "Yes" : "No"}</p>} />
                    <Column field="sv_DocumentCompleteStatus" header="SV Document Status" body={(rowData) => <p style={rowData.sv_DocumentCompleteStatus === true ? {} : { color: "red" }}>{rowData.sv_DocumentCompleteStatus === true ? "Yes" : "No"}</p>} />
                    <Column header="Paid Amout" body={(rowData: ISubvendorInvoiceList, options) => {
                        return <InputText placeholder={"Enter Paid Amount"} value={rowData.paidAmount || rowData.invoiceAmount} type="number" onChange={(e: any) => {
                            let newTableData = tableData.tableData;
                            let newSelectedTableData = selectedSubvendorInvoices;
                            newTableData[options.rowIndex].paidAmount = e.target.value;
                            newSelectedTableData = newSelectedTableData.map((item) => {
                                if (item.id === rowData.id) {
                                    item.paidAmount = e.target.value;
                                }
                                return item;
                            });
                            setSelectedSubvendorInvoices(newSelectedTableData);
                            newTableData[options.rowIndex].paymentStatus = getPaymentStatus(newTableData[options.rowIndex]?.invoiceAmount || 0, e.target.value);
                            setTableData({ tableData: newTableData, loading: false });
                        }} />
                    }} footer={() => {
                        const PO = selectedSubvendorInvoices.reduce((sum: any, item: any) => sum + Number((item.paidAmount || item.invoiceAmount)), 0);
                        return <span className="font-bold">{PO}</span>;
                    }} />
                    <Column field="paymentStatus" header="Payment Status" body={(rowData) => <p>{rowData.paymentStatus === "-- SELECT --" ? "" : rowData.paymentStatus}</p>} />
                    <Column header="Deduction" body={(rowData: ISubvendorInvoiceList, options) => {
                        return <InputText placeholder={"Enter Deduction Amount"} value={rowData.deduction || 0} type="number" onChange={(e: any) => {
                            let newTableData = tableData.tableData;
                            let newSelectedTableData = selectedSubvendorInvoices;
                            newTableData[options.rowIndex].deduction = e.target.value;
                            newSelectedTableData = newSelectedTableData.map((item) => {
                                if (item.id === rowData.id) {
                                    item.deduction = e.target.value;
                                }
                                return item;
                            });
                            setSelectedSubvendorInvoices(newSelectedTableData);
                            setTableData({ tableData: newTableData, loading: false });
                        }} />
                    }} footer={() => {
                        const Deduction = selectedSubvendorInvoices.reduce((sum: any, item: any) => sum + Number((item.deduction || 0)), 0);
                        return <span className="font-bold">{Deduction}</span>;
                    }} />
                    <Column header="Balance" body={(rowData: ISubvendorInvoiceList, options) => {
                        return <InputText placeholder={"Enter Paid Amount"} value={Number(rowData.invoiceAmount || 0) - (Number(rowData.paidAmount || rowData.invoiceAmount) + Number(rowData.deduction || 0))} type="number" />
                    }} footer={() => {
                        const PO = selectedSubvendorInvoices.reduce((sum: any, item: any) => sum + Number(item.invoiceAmount || 0) - (Number(item.paidAmount || item.invoiceAmount) + Number(item.deduction || 0)), 0);
                        return <span className="font-bold">{PO}</span>;
                    }} />
                    <Column header="Remarks" body={(rowData: ISubvendorInvoiceList, options) => {
                        return <InputText placeholder={"Enter Remarks"} value={rowData.remarks || ""} type="text" onChange={(e: any) => {
                            let newTableData = tableData.tableData;
                            let newSelectedTableData = selectedSubvendorInvoices;
                            newTableData[options.rowIndex].remarks = e.target.value;
                            newSelectedTableData = newSelectedTableData.map((item) => {
                                if (item.id === rowData.id) {
                                    item.remarks = e.target.value;
                                }
                                return item;
                            });
                            setSelectedSubvendorInvoices(newSelectedTableData);
                            setTableData({ tableData: newTableData, loading: false });
                        }} />
                    }} />
                </DataTable>
            </Dialog>
        </>
    );
}